<template>
  <section class="meet-experts-container content-max-width">
    <div class="search">

      <div class="form-fields-stack">

        <div class="form-field text search">
          <label>Search experts</label>
          <input type="text"
            placeholder="Start typing..."
            v-model="payload.keyword" v-debounce:750ms="loadKeywords"
          >
        </div>

        <div class="form-field select">
          <label for="">Filter by type</label>
          <select v-model="payload.occupation" >
            <option
              v-for="item of filter"
              :value="item.value"
              :key="item.id"
            >
              {{ item.label }}
            </option>
          </select>
        </div>

        <div class="form-field select">
          <label for="">Filter by region</label>
          <select
            v-model="payload.region"
          >
            <option
              v-for="region of regions"
              :value="region.value"
              v-bind:key="region.id"
            >
              {{ region.label }}
            </option>
          </select>
        </div>

        <button
          class="button grey-border"
          @click="clearAll"
        >
          <span class="icon-clear"></span> Clear filter
        </button>
      </div>

    </div>

    <div class="experts flex" id="exp-container" v-if="experts.length">

      <article v-for="(person, index) of experts" :key="index">

        <div class="wrap flex"
          :class="{ 'active' : person.name === activePerson.name }"
          :id="'container' + index"
          @click="toggleInfo(index)"
        >
          <div class="name">
            <h3>{{ person.name }}</h3>
          </div>
          <img :src="person.thumbnail" :alt="'Habit Health:' + person.name">
        </div>

        <div class="dropdown-container flex">
          <button class="close-dropdown" @click="activePerson = {}">
            <img src="/images/icons/close.svg" alt="close dropdown button">
          </button>

          <div class="image">
            <a :href="getUrl(person.name)">
                <img :src="person.hero" :alt="'Habit Health:' + person.name">
            </a>
          </div>

          <div class="content">

            <div class="info">
              <h3>{{ person.name }}</h3>
              <h4>{{ person.position }}</h4>
              <a :href="person.link" class="button">Book Now</a>
            </div>

            <div class="wysiwyg" v-html="person.description">

            </div>

          </div>
        </div>

      </article>

    </div>

    <div class="experts flex flex-center" v-else>
      <h4>We couldn't find that person. Try <a href="/contact-us" style="font-family:inherit; font-size:inherit; font-weight:inherit;">contacting us</a> instead</h4>
    </div>

    <div
      class="load-more content-max-width"
      @click="loadMore"
      :disabled="isDisabled"
      v-if="nextUrl"
    >
      <a href="#load-more" class="load-more-btn button large blue-border">Load More</a>
    </div>

  </section>
</template>

<script>
export default {
  props: {
    filter: Array,
    regions: Array,
    url: String
  },

  data () {
    return {
      experts: [],
      activePerson: {},
      isDisabled: false,
      nextUrl: null,
      payload: {
        occupation: this.filter[0].value,
        region: this.regions[0].value,
        expert: '',
        page: 1,
        keyword: '',
      },
    };
  },

  computed: {
    selectedRegion () {
      if (this.payload.region !== 0) {
        return this.regions.find(obj => obj.value === this.payload.region)
      } else {
        let obj = { 'label': 'All Regions', 'value': 0 }
        return obj
      }
    },

    selectedOccupation () {
      if (this.payload.occupation !== 0) {
        return this.filter.find(obj => obj.value === this.payload.occupation)
      } else {
        let obj = { 'label': 'All Experts', 'value': 0 }
        return obj
      }
    }
  },

  watch: {
    'payload.occupation' () {
      this.experts = []
      this.payload.page = 1
      this.loadExperts()
    },
    'payload.region' () {
      this.experts = []
      this.payload.page = 1
      this.loadExperts()
    }
  },

  mounted () {
    console.log('mounted')
    if (window.location.search) {
      let url = new URL(window.location.href)
      let occupation = url.searchParams.get('occupation')
      let region = url.searchParams.get('region')

      if (occupation) {
        let occ = this.filter.find(obj => obj.label === occupation)
        if (occ) {
          this.payload.occupation = occ.value
        } else {
          this.payload.occupation = 0
        }
      }
      if (region) {
        let reg = this.regions.find(obj => obj.label === region)
        this.payload.region = reg.value
        // console.log('reg', region, reg)
      }
    }
    this.loadExperts()
  },

  methods: {
    getUrl(name) {
        return '/about-us/meet-our-experts?expert=' + name
    },
    loadKeywords () {
      this.payload.page = 1
      this.loadExperts()
    },

    loadMore () {
      this.payload.page = this.payload.page + 1
      this.loadExperts()
    },

    loadExperts () {
      this.$store.commit('setLoading', true)
      this.isDisabled = true
      let windowUrl = new URL(window.location.href)
      this.payload.expert = windowUrl.searchParams.get('expert')

      // axios call to search here
      let url = '?'
      url += '&occupation=' + this.payload.occupation
      url += '&region=' + this.payload.region
      url += '&keyword=' + this.payload.keyword
      url += '&page=' + this.payload.page

      if (this.payload.expert !== null && this.payload.expert !== '') {
          url += '&expert=' + this.payload.expert
      }

      // console.log(url)
      let urlWithWords = '?'
      urlWithWords += 'occupation=' + this.selectedOccupation.label
      urlWithWords += '&region=' + this.selectedRegion.label
      urlWithWords += '&keyword=' + this.payload.keyword
      urlWithWords += '&page=' + this.payload.page

      if (this.payload.expert) {
          urlWithWords += '&expert=' + this.payload.expert
      }

      history.pushState(this.payload, '', '/about-us/meet-our-experts' + urlWithWords)

      // window.axios.get(this.url, { params: this.payload })
      window.axios.get(this.url + url)
        .then((response) => {
          this.$store.commit('setLoading', false)
          console.log('res', url, response.data.data)

          if (this.payload.page == 1) {
            this.experts = response.data.data
          } else {
            this.experts = this.experts.concat(response.data.data)
          }

          this.nextUrl = response.data.links.next

          if (this.payload.expert) {
            let index = this.experts.findIndex(obj => obj.name === this.payload.expert)
            this.toggleInfo(index)
            this.scrollToElement(index)
            console.log('exp', index)
        }
        })
        .catch((error) => {
          console.log('prodd error', error)
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            content: '<p>Sorry, the list could not be loaded.</p>',
            open: true
          })
        })
    },

    scrollToElement(index) {
        let container = document.querySelector('.experts')

        container.scrollIntoView({behavior: 'smooth'})
    },

    toggleInfo (index) {
      this.activePerson = this.experts[index]
    },

    clearAll () {
      this.payload.keyword = ''
      this.payload.occupation = this.filter[0].value
      this.payload.region = this.regions[0].value
      this.payload.expert = ''
      this.activePerson = {}
      this.loadExperts()
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/meet-experts/Index.vue